import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  semanticCSS,
  TypographySizes,
} from '../../typography/semanticTags/semanticTags.utils';
import { useTheme } from '../../theming/useTheme';
import { TranslatedFontSize } from '../../theming/fontSizeTranslator';
import { BaseUnit } from '../../theming/baseUnitDefinition';
import { extractWrapperAndContentFromHtml } from '../components.utils';
import { P } from '../../typography/semanticTags';

interface IntroComponentProps {
    html: string;
    styles?: ReturnType<typeof semanticCSS>;
}

const getStyle = (textColor: string, baseUnit: BaseUnit) => {
  return (element: string) => {
    switch (element) {
      case 'ul': return StyleSheet.create({
        style: {
          padding: 0,
          color: textColor,
        },
      }).style;
      case 'li': return StyleSheet.create({
        style: {
          marginLeft: baseUnit,
          color: textColor,
        },
      }).style;
      case 'p': return StyleSheet.create({
        style: {
          color: textColor,
        },
      }).style;
      default: return null;
    }
  };
};

const applyCssClasses = (html: string, textColor: string, fontSizesStyles: TranslatedFontSize, baseUnit: BaseUnit): string => {
  const style = getStyle(textColor, baseUnit);
  return html
    .replace(/<ul/g, `<ul class="${css(style('ul'))}"`)
    .replace(/<li/g, `<li class="${css(style('li'))}"`);
};

export const Intro: React.FunctionComponent<IntroComponentProps> = props => {
  const { html, styles = [] } = props;
  const { fontSizesStyles, baseUnit, colors } = useTheme();
  const { wrapper: Wrapper, content } = extractWrapperAndContentFromHtml(html);
  const additionalStyle = StyleSheet.create({
    style: {
      margin: `${baseUnit * 0.5}px ${baseUnit}px`,
      color: colors.darkGrey,
    },
  });
  return (
    <P
      fontSizeSmall={TypographySizes.LARGE}
      fontSizeMedium={TypographySizes.LARGE}
      fontSizeLarge={TypographySizes.LARGE}
      styles={semanticCSS(additionalStyle.style, styles)}
    >
      <Wrapper
        {...{
          dangerouslySetInnerHTML: { __html: applyCssClasses(content, colors.darkGrey, fontSizesStyles, baseUnit) },
          key: 'intro',
        }}
      />
    </P>
  );
};
